import { R, S } from 'core/helpers'
import { enginePilots } from 'core/resources'

type NavGroup = { label: string; items: Array<NavItem> }

export type NavItem =
  | string
  | Array<unknown>
  | NavGroup
  | { key?: string; label?: string; to?: string }

const isGroup = (item: NavItem): item is NavGroup =>
  !Array.isArray(item) && typeof item === 'object' && 'items' in item

const labelFor = (slug: string): string =>
  S.capitalCase(R.last(slug.split('/')) as string)

const replaceEntry = (
  items: Array<NavItem>,
  from: string,
  to: string,
): { items: Array<NavItem>; replaced: boolean } => {
  let replaced = false

  const next = items.map((item): NavItem => {
    if (item === from) {
      replaced = true
      return { key: from, label: labelFor(from), to }
    }

    if (isGroup(item)) {
      const group = replaceEntry(item.items, from, to)
      if (group.replaced) {
        replaced = true
        return { ...item, items: group.items }
      }
    }

    return item
  })

  return { items: next, replaced }
}

const enginePilotNav = (items: Array<NavItem>): Array<NavItem> => {
  const missing: Array<string> = []

  const rewritten = enginePilots.reduce((current, pilot) => {
    const from = `/${pilot.replacesNavSlug ?? pilot.slug}`
    const result = replaceEntry(current, from, `/${pilot.slug}`)

    if (!result.replaced) missing.push(`/${pilot.slug}`)

    return result.items
  }, items)

  if (missing.length === 0) return rewritten

  const firstGroup = rewritten.findIndex(isGroup)
  const at = firstGroup === -1 ? rewritten.length : firstGroup

  return [...rewritten.slice(0, at), ...missing, ...rewritten.slice(at)]
}

export default enginePilotNav
